function createEstablishingContextErr(message){return{name:"ErrEstablishingContext",statusCode:"404",message:`Not found: ${message}`}}export{createEstablishingContextErr};
